import { usePlatoUserContext } from '../../features/plato-user-layout/components/plato-user-layout.tsx';
import type { PlatoUserInContext } from '../../utils/plato-user.ts';
import { useImpersonation } from './use-impersonation.ts';

export type AppState = {
    platoUser: PlatoUserInContext;
    tenantId: string;
    salesRepId?: string;
    salesRepIds: string[];
    impersonatedUserId?: string;
    superAdminImpersonatingPlatoUserId?: string;
};

export function useAppState(): AppState {
    const platoUser = usePlatoUserContext();
    const [impersonatedUserId] = useImpersonation();

    let salesRepId: string | undefined;
    if (platoUser.showDataForErpSalesRepId && platoUser.erpSalesRepId) {
        salesRepId = platoUser.erpSalesRepId;
    }

    return {
        platoUser,
        tenantId: platoUser.platoCustomer.id,
        salesRepId,
        salesRepIds: platoUser.salesRepIds,
        impersonatedUserId,
        superAdminImpersonatingPlatoUserId: impersonatedUserId,
    };
}
